import {getBaseUrl} from "../utils";
import {fetchClientJWT} from "../API/User";
import {GAEvent} from "./GA";
import {colorRed, colorSecondary, colorText} from "./theme";
import {Box, Checkbox, FormControlLabel, Typography} from "@mui/material";
import {TypingLabel} from "../Components/TypingLabel";
import {GoogleLogin, GoogleOAuthProvider} from "@react-oauth/google";
import Loader from "../Loaders/LocalLoader";
import * as React from "react";
import {getQueryParamValue, is_on_premises} from "./utils";

function urlWithParam(url, newParams) {
    const urlObj = new URL(url);
    const searchParams = urlObj.searchParams;
    Object.entries(newParams).forEach(([key, value]) => {
        searchParams.set(key, value);
    });
    return urlObj.toString();
}

export const AuthScreen = ({
    setShowError, termsAccepted, login, subscribed, setTokenExpired, setLoading, path, fromTokenExpired = null,
    fromInstallAppId, appToInstall, setTermsAccepted, setSubscribed, showError, isLoading
}) => {
    let signup = path?.startsWith('/signup') ||
        !localStorage.getItem('APICache') && !path?.startsWith('/signin') ||
        getQueryParamValue('isSignup') === '1'

    if (getQueryParamValue('isSignup') === '0') signup = false;

    const baseURL = is_on_premises ? 'https://openkbs.com' : getBaseUrl()

    const fromCLI = getQueryParamValue('from_cli');

    if (fromCLI) GAEvent("from_cli_auth_screen", { value: 1 })

    let suffix = fromCLI ? '?from_cli=1' : ''
    const termsOfUse = `${baseURL}/terms-of-use`;
    const signinLink = fromInstallAppId ? urlWithParam(window.location.href, {isSignup: '0'}) : `${baseURL}/signin${suffix}`;
    const signupLink = fromInstallAppId ? urlWithParam(window.location.href, {isSignup: '1'}) : `${baseURL}/signup${suffix}`;
    const privacyPolicy = `${baseURL}/privacy-policy`;

    const handleError = () => {
        console.log('Authentication Failed');
        // Handle login error logic here
    };

    async function handleSuccessLogin(credentialResponse) {
        setLoading(true);
        setTokenExpired(false);
        try {
            const response = await fetchClientJWT({
                subscribed,
                signup,
                inputJWT: credentialResponse.credential
            })

            const res = response?.data;

            if (response?.status === 201) {
                GAEvent({
                    category: "signup",
                    action: 'post_registration_url',
                    label: window.location.pathname,
                    value: 10
                })
            }

            login(res.clientJWT, fromTokenExpired, response?.status === 201, fromInstallAppId);
        } catch (e) {
            if (e?.response?.status === 404) {
                window.location.href = signupLink;
            }

            if (e?.response?.status === 552) {
                alert('Account Suspended');
                return;
            }

        } finally {
            setLoading(false);
        }

    }

    const handleSignup = () => {
        if (!termsAccepted) {
            setShowError(true);
            return;
        }
    };

    const linkStyle = {color: colorSecondary, textDecoration: 'none'};

    let title = 'Welcome to OpenKBS';
    if (is_on_premises) {
        title = 'OpenKBS Local Server';
    }

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                width: '100vw',
                height: '100vh',
                backgroundColor: 'background.default',
            }}
        >
            <Box
                sx={{
                    width: '90%',
                    maxWidth: '400px',
                    backgroundColor: 'background.paper',
                    borderRadius: '8px',
                    boxShadow: 3,
                    p: 4,
                }}
            >
                <br />
                <Typography variant="h4" component="h1" gutterBottom align="center" color={"primary"}>
                    {fromTokenExpired
                        ? 'Session Expired'
                        : ( signup
                                ? ( fromInstallAppId ? appToInstall?.kbTitle?.split(':')[0] : 'Sign up for OpenKBS')
                                : title
                        )}
                </Typography>


                {fromInstallAppId && <div gutterBottom align="center" style={{marginTop: 30, marginBottom: 30}}>
                    <img src={`https://file.openkbs.com/app-image/${encodeURIComponent(fromInstallAppId)}.png`} style={{width: 300}} />
                </div>}

                {fromInstallAppId && appToInstall && <Typography  gutterBottom align="center" color="primary" fontSize={18}>
                    {signup ? <TypingLabel text={`Join to Activate Your Free Credits`} speed={20} /> : ''}
                </Typography>}

                <br />



                <div style={{ position: 'relative', display: 'inline-block', width: '100%' }}>
                    <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}>
                        <GoogleLogin
                            text={signup ? "signup_with" : "signin_with"}
                            theme="outline"
                            onSuccess={handleSuccessLogin}
                            onError={handleError}
                        />
                    </GoogleOAuthProvider>
                    {signup && !termsAccepted && <div
                        onClick={handleSignup}
                        style={{
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            width: '100%',
                            height: '100%',
                            zIndex: 1,
                            background: 'transparent',
                        }}></div>}
                </div>
                <br />
                {signup && <br/>}
                {signup && (
                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={termsAccepted}
                                onChange={(e) => {
                                    setTermsAccepted(e.target.checked);
                                    setShowError(!e.target.checked);
                                }}
                                color="primary"
                            />
                        }
                        sx={{color: showError ? colorRed : colorText}}
                        label="I agree to the terms and conditions"
                    />
                )}

                {signup && <br /> }
                {signup && (
                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={subscribed}
                                onChange={(e) => {
                                    setSubscribed(e.target.checked);
                                }}
                                color="primary"
                            />
                        }
                        sx={{color: colorText}}
                        label="Subscribe to receive updates and promotions"
                    />
                )}

                <br />
                {!signup && <Typography variant="body2" sx={{ mt: 4, textAlign: 'center', color: colorText }}>
                    Don't have an account?&nbsp;<a href={signupLink} style={linkStyle}>Sign up</a>
                </Typography>}
                {signup && <Typography variant="body2" sx={{mt: 4, textAlign: 'center', color: colorText}}>
                    Already have an account?&nbsp;<a href={signinLink} style={linkStyle}>Sign in</a>
                </Typography>}

                <Typography variant="body2" sx={{mt: 8, textAlign: 'center', color: colorText}}>
                    Before using this app, you can review <br/>OpenKBS’s{' '}
                    <a href={privacyPolicy} target={"_blank"} style={linkStyle}>
                        privacy policy
                    </a>{' '}
                    and{' '}
                    <a href={termsOfUse} target={"_blank"} style={linkStyle}>
                        terms of service
                    </a>
                </Typography>
            </Box>
            <Loader open={isLoading} />
        </Box>
    );
}